/**
 * Se va a descargar todos los archivos que se encuentren dentro de la carpeta 'public'
 */
export const download = (filename) => {
    const link = document.createElement('a');
    link.href = `/${filename}`;
    link.download = `${filename}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}